// extracted by mini-css-extract-plugin
export default {"container":"Q7fsO","placeholder":"wY7WY"};